import styled from "styled-components";
import { LinkStyle } from "storybook-components/Link";
import { LfCaptionStyle } from "storybook-components/TypographyStyle";
import {
  BodyStyle,
  H3Style,
  H4Style,
  H5Style,
  SubheadSmStyle,
  SubheadLgStyle,
  BodySemiboldStyle
} from "storybook-components/Typography";

const BlogPostStyleWrapper = styled.div`
  max-width: 970px;
  line-height: 1.7;
  h1 {
    ${H3Style}
    line-height: 115%;
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
  h2 {
    ${H4Style}
    line-height: 120%;
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
  h3 {
    ${H5Style}
    line-height: 125%;
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
  h4,
  h5 {
    ${SubheadSmStyle}
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
  p {
    ${BodyStyle}
  }
  a {
    ${LinkStyle}
    text-decoration: underline;
    margin-left: 0;
    font-weight: 400;
  }
  ul,
  ol {
    margin-top: 1.5rem;
  }
  li {
    ${BodyStyle}
    margin-bottom: 1.5rem;
  }
  figcaption {
    ${LfCaptionStyle}
    max-width: 90%;
    text-align: center;
  }
  code {
    background: ${({ theme }) => theme.colors.gray1200};
    border-radius: 2px;
    padding: 2px 4px;
  }
  pre {
    overflow: scroll;
    position: relative;
    word-wrap: normal;
    padding: 16px 24px;
    margin-top: 0;
    margin-bottom: 32px;
    background-color: ${({ theme }) => theme.colors.gray1200};
    border: 0;
    max-width: 100%;
  }
  code {
    color: ${({ theme }) => theme.colors.white};
    font-size: 0.85rem;
    line-height: 1.5;
  }
  table {
    border-collapse: collapse;
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    tbody tr:nth-child(odd) {
      background-color: ${({ theme }) => theme.colors.gray300};
    }
    th,
    td {
      padding: 0.25rem 1rem;
    }
    th {
      font-weight: 500;
      text-align: left;
    }
  }

  img {
    max-width: 100%;
  }

  strong {
    font-weight: 500;
  }

  blockquote {
    margin: 56px auto;
    p {
      ${SubheadLgStyle}
      color: ${({ theme }) => theme.colors.green5};
      ${props => props.theme.media.phoneUp`
      margin-inline-start: 2.5rem;
      margin-inline-end: 2.5rem;
      `};
      strong {
        color: ${({ theme }) => theme.colors.green5};
        ${BodySemiboldStyle}
      }
    }
  }

  iframe {
    display: block;
    margin: 5rem auto;
    max-width: 100%;
  }

  .center {
    text-align: center;
  }
`;

export default BlogPostStyleWrapper;
